// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"9ed70a19","336":"756e614b","355":"66c7b43b","658":"107481b0","787":"32d2f0b8"}[chunkId] + ".chunk.js";
};